import { useContext, useState } from 'react'
import { InlineAlert, InputCheckbox } from '../BaseComponents'
import { SettingsItem } from '../SettingsLayout/SettingsLayout'
import useUserData from '../../hooks/useUserData'
import useApi from '../../hooks/useApi'
import useIsViewOnly from '../../hooks/useIsViewOnly'
import { userContext } from '../../context/UserContext'
import { getCSRFToken } from '../../lib/utils'

function FictitiousOrganisationsPreference() {
	const userData = useUserData()
	const { fetchUserData } = useContext(userContext)
	const api = useApi()
	const isViewOnly = useIsViewOnly()
	const [saving, setSaving] = useState(false)
	const [error, setError] = useState<string | null>(null)

	const checked = userData.showFictitiousOrganisations !== false

	const onChange = async (next: boolean) => {
		setSaving(true)
		setError(null)
		try {
			await api.put('me/preferences', {
				_csrf: await getCSRFToken(),
				showFictitiousOrganisations: next,
			})

			// Hiding fictitious organisations while inside one returns the user to the organisation picker.
			const memberships = userData.memberships ?? []
			const current = memberships.find((membership) => membership.companyId === userData.original?.companyId)
			if (!next && current?.fictitiousKind && memberships.some((membership) => !membership.fictitiousKind)) {
				await api.post('organisations/clear', { _csrf: await getCSRFToken() })
				window.location.assign('/')
				return
			}

			await fetchUserData?.()
		} catch (_) {
			setError('Failed to save this preference. Please try again.')
		} finally {
			setSaving(false)
		}
	}

	return (
		<SettingsItem title='Organisation visibility'>
			<label className='flex items-center gap-2'>
				<InputCheckbox checked={checked} disabled={saving || isViewOnly} onChange={(e) => onChange(e.target.checked)} />
				Show demo, sample and training organisations
			</label>
			<div className='text-charcoal-100 text-sm'>Controls which organisations appear in the organisation switcher and picker.</div>
			{error && <InlineAlert type='error' className=''>{error}</InlineAlert>}
		</SettingsItem>
	)
}

export default FictitiousOrganisationsPreference
